module.exports = "/_next/static/images/ab5667a9c38116ff4b6e7cf024e3f9c5-hero-xs.jpg";